import { render, staticRenderFns } from "./AddressChoise.vue?vue&type=template&id=a5b2c13c&scoped=true&"
import script from "./AddressChoise.vue?vue&type=script&lang=js&"
export * from "./AddressChoise.vue?vue&type=script&lang=js&"
import style0 from "./AddressChoise.vue?vue&type=style&index=0&id=a5b2c13c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b2c13c",
  null
  
)

export default component.exports